'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import NProgress from 'nprogress';

// Configure NProgress
NProgress.configure({
  minimum: 0.3,
  easing: 'ease',
  speed: 500,
  showSpinner: false,
});

export default function ProgressBar() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    NProgress.done();
  }, [pathname, searchParams]);

  return null;
}

// Hook to start progress on route change
export const useProgress = () => {
  const startProgress = () => {
    NProgress.start();
  };

  const finishProgress = () => {
    NProgress.done();
  };

  return { startProgress, finishProgress };
};
